import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import AlertExample from './AlertExample.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Alert is component to displays a short message or notification to the user from an existing activity.`}</p>
    <h2>{`Usage`}</h2>
    <br />
To implement Alert, you can use this tag `LgnAlertButton` in the xml file.
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:alertType="INFO"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`In its use, alert has following variants :`}</p>
    <ol>
      <li parentName="ol">{`Themes`}</li>
      <li parentName="ol">{`Alert Button`}</li>
    </ol>
    <h3>{`Themes`}</h3>
    <p>{`There are 4 themes which are available :`}</p>
    <h4>{`1. Info`}</h4>
    <p>{`The following is properties value to implement Alert `}<inlineCode parentName="p">{`info`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:alertType="INFO"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <h4>{`2. Success`}</h4>
    <p>{`The following is properties value to implement Alert `}<inlineCode parentName="p">{`Success`}</inlineCode>{` .`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:alertType="SUCCESS"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <h4>{`3. Warning`}</h4>
    <p>{`The following is properties value to implement Alert `}<inlineCode parentName="p">{`Warning`}</inlineCode>{` .`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:alertType="WARNING"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <h4>{`4. Error`}</h4>
    <p>{`The following is properties value to implement Alert `}<inlineCode parentName="p">{`Error`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:alertType="ERROR"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <h3>{`Alert Button`}</h3>
    <p>{`Alert consists of 2 action buttons :`}</p>
    <ol>
      <li parentName="ol">{`Action button `}<inlineCode parentName="li">{`app:actionText`}</inlineCode></li>
      <li parentName="ol">{`Dismiss button `}<inlineCode parentName="li">{`app:isDismissible`}</inlineCode></li>
    </ol>
    <p>{`The following is example usage for alert button, this code represent alert with `}<inlineCode parentName="p">{`action button`}</inlineCode>{` and `}<inlineCode parentName="p">{`dismiss button`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:actionText="Call to action"
  app:description="Interactively monetize corporate alignment"
  app:title="Info title"
/>
`}</code></pre>
    <p>{`The following is example usage for alert button, this code represent alert without `}<inlineCode parentName="p">{`action button`}</inlineCode>{` and `}<inlineCode parentName="p">{`dismiss button`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<com.telkom.legion.component.alert.LgnAlert
  android:layout_width="match_parent"
  android:layout_height="wrap_content"
  android:layout_marginHorizontal="@dimen/dimen_16dp"
  android:layout_marginTop="@dimen/dimen_20dp"
  app:description="Interactively monetize corporate alignment"
  app:isDismissible="false"
  app:title="Info title"
/>
`}</code></pre>
    <div className="divi" />
    <h2>{`Attributes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Xml Attrs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Related method(s)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Alert Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:title`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Add title on alert`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Alert Description`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:description`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.description`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Add description on alert`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Alert Action Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:actionText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.actionText`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Add action text on alert`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Alert Dissmis Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isDismissible`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.isDismissible`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Add dismiss button visibility on alert`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Alert Type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:alertType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`.alertType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Configure alert type`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h2>{`Example`}</h2>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/alert/alert_android.gif",
            "align": "center",
            "resize-mode": "contain"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <div className="divi" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      